/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type BurnUpReportEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const burnUpReportEntrypoint: EntryPoint<BurnUpReportEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<BurnUpReportEntrypointComponent>(
			/* webpackChunkName: "async-next-gen-reports-burn-up-entrypoint" */ './index.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
